export const USER_LOADED = "USER_LOADED";
export const USER_LOADING = "USER_LOADING";
export const AUTH_ERROR = "AUTH_ERROR";
export const LOGIN_SUCCESS = "LOGIN_SUCCESS";
export const LOGIN_FAIL = "LOGIN_FAIL";
export const LOGOUT_SUCCESS = "LOGOUT_SUCCESS";
export const GET_ERRORS = "GET_ERRORS";
export const IS_LOADING = "IS_LOADING";

// export const API_URL = `http://freeipa.gdpanalytics.local:9000/api/authentication/`;
// export const WAVE_USERS_URL = `http://freeipa.gdpanalytics.local:9000/api/users/`;
// export const URL_ADMIN = `http://localhost:3005/`;
// export const URL_SEA = `http://localhost:3001/`;
// export const URL_OIL = `http://localhost:3002/`;
// export const URL_RES = `http://localhost:3003/`;
// export const URL_OFFSHORE = `http://localhost:3004/`;

export const API_URL = `https://energyplat.est.polito.it/api/authentication/`;
export const WAVE_USERS_URL = `https://energyplat.est.polito.it/api/users/`;
export const URL_ADMIN = `https://energyplat.est.polito.it/admin_panel/`;
export const URL_SEA = `https://wave.est.polito.it/`;
export const URL_OIL = `https://oil.est.polito.it/`;
export const URL_RES = `https://res.est.polito.it/`;
export const URL_OFFSHORE = `https://offwind.est.polito.it/`;
